module.exports = __webpack_public_path__ + "img/icon-zoom-out.51c17ac1.svg";